import React, { useEffect } from 'react';
import Classnames from 'classnames';
import { BackArrowButton, CloseButton } from '../../../../../components/common';
import { useDispatch } from 'react-redux';
import { setPageIsNotDashboard } from '../../../../../store/slices/partner-portal';

import './portal-header-layout.scss';

interface PortalHeaderLayoutProps {
    isDetail?: boolean;
    buttonElement?: React.ReactNode;
    isSingleRow?: boolean;
    title?: string;
    titleIcon?: string;
    onBackArrowClick?: () => void;
    onClose?: () => void;
}

export const PortalHeaderLayout: React.FC<PortalHeaderLayoutProps> = ({
    children,
    isDetail = false,
    isSingleRow = false,
    title = '',
    titleIcon = '',
    onBackArrowClick,
    onClose,
    buttonElement,
}): React.ReactElement => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setPageIsNotDashboard(isDetail));
    }, [isDetail]);

    const classnamesContent = Classnames('portal-header-layout__content', {
        'portal-header-layout__content--is-detail': isDetail,
        'portal-header-layout__content--two-columns': isSingleRow,
    });

    const classnamesTitle = Classnames('portal-header-layout__title', {
        'portal-header-layout__title--has-icon': !!titleIcon,
    });

    const classnamesTitleContainer = Classnames('portal-header-layout__title-container', {
        'portal-header-layout__title-container--has-button': buttonElement,
    });
    const handleBackArrowClick = () => {
        dispatch(setPageIsNotDashboard(false));
        onBackArrowClick?.call(null);
    };

    const handleClose = () => {
        dispatch(setPageIsNotDashboard(false));
        onClose?.call(null);
    };

    const renderTitle = () => {
        if (isDetail && !title && !titleIcon) {
            return null;
        }

        return (
            <div className={classnamesTitleContainer}>
                <h1 data-testid="portal-header-layout-title" className={classnamesTitle}>
                    {titleIcon && <img alt="" src={titleIcon} />}
                    {title}
                </h1>
                {buttonElement && buttonElement}
            </div>
        );
    };

    return (
        <div className="portal-header-layout z-index-header">
            <div className={classnamesContent}>
                {onClose && <CloseButton onClick={handleClose} />}
                {onBackArrowClick && <BackArrowButton onClick={handleBackArrowClick} />}
                {renderTitle()}
                {children}
            </div>
        </div>
    );
};
